import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import s from './ModelCategoryConfigurationTabs.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { useParams } from 'react-router-dom';

const Tab = ({ selectedPage, pageComponent, url, title }) => (
  <Fragment>
    <Link className={classNames({ [s.active]: selectedPage === pageComponent })} to={url}>
      {title}
      {selectedPage === pageComponent && <span />}
    </Link>
  </Fragment>
);

const ModelCategoryTabs = ({ selectedPage, userProfileWidgets }) => {
  let { ModelCategoryId } = useParams();
  return (
    <ul className={s.tabNav}>
      {IsWidgetAccessible(userProfileWidgets, 'MODELS_TAB') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-list`}
            title={<FormattedMessage id="modelCategoryTabs.models" defaultMessage="Models" />}
            selectedPage={selectedPage}
            pageComponent="manageModels"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTTYPE_LIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-type-list`}
            title={<FormattedMessage id="modelCategoryTabs.componentTypes" defaultMessage="Component Types" />}
            selectedPage={selectedPage}
            pageComponent="manageComponentType"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'APPROVEDCOMPONENT_LIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/approved-component-list`}
            title={<FormattedMessage id="modelCategoryTabs.approvedComponents" defaultMessage="Approved Components" />}
            selectedPage={selectedPage}
            pageComponent="manageApprovedComponents"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTPOSITION_LIST') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-position-list`}
            title={<FormattedMessage id="modelCategoryTabs.componentPositions" defaultMessage="Component Positions" />}
            selectedPage={selectedPage}
            pageComponent="manageComponentPosition"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATIONS_TAB') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`}
            title={<FormattedMessage id="modelCategoryTabs.signalTranslations" defaultMessage="SignalTranslations" />}
            selectedPage={selectedPage}
            pageComponent="manageSignalTranslations"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'SETPOINTS_TAB') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints`}
            title={<FormattedMessage id="modelCategoryTabs.setpoints" defaultMessage="Setpoints" />}
            selectedPage={selectedPage}
            pageComponent="setpoints"
          />
        </li>
      )}
      {IsWidgetAccessible(userProfileWidgets, 'EVENTCODES_TAB') && (
        <li>
          <Tab
            url={`/operational-setup/model-category-configuration/${ModelCategoryId}/event-code-list`}
            title={<FormattedMessage id="modelCategoryTabs.eventCodes" defaultMessage="Event Codes" />}
            selectedPage={selectedPage}
            pageComponent="manageEventCodes"
          />
        </li>
      )}


    </ul>
  )
};

ModelCategoryTabs.propTypes = {
  selectedPage: PropTypes.string.isRequired
};

export default ModelCategoryTabs;
